var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "button_add mb-4" }, [
    _c(
      "button",
      {
        staticClass:
          "btn btn-md btn-block btn-outline-info waves-effect waves-themed",
        on: { click: _vm.add_item },
      },
      [
        _c("span", { staticClass: "fal fa-eject mr-1" }),
        _vm._v("\n        " + _vm._s(_vm.__t("ADD")) + "\n    "),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "time_info" }, [
      _c(
        "ul",
        { staticClass: "list-style-none" },
        _vm._l(this.items, function (item, idx) {
          return _c("li", { staticClass: "mt-2 list-style-none" }, [
            _c("div", { staticClass: "row row-no-padding" }, [
              _c("div", { staticClass: "col-10" }, [
                _c("div", { staticClass: "input-group flex-nowrap" }, [
                  _vm._m(0, true),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: item.param_val,
                        expression: "item.param_val",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { id: _vm.cur_type + idx, type: "text" },
                    domProps: { value: item.param_val },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(item, "param_val", $event.target.value)
                      },
                    },
                  }),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-2" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-danger w-100",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.remove(idx)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.__t("REMOVE")) +
                        "\n                        "
                    ),
                  ]
                ),
              ]),
            ]),
          ])
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", { staticClass: "fal fa-typewriter fs-xl" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }